import { inject, Injectable } from '@angular/core';
import {
  RegisterSendOtpRequest,
  RegisterVerifyEmailRegisteredRequest,
  RegisterVerifyOtpRequest,
  RegisterVerifyEmailRegisteredResponse,
} from '../interfaces/register-verify-contact.model';
import { API_ENDPOINTS } from '../constants/api.constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class RegisterVerifyContactService {
  http: HttpClient = inject(HttpClient);

  /**
   * 發送/重新發送 OTP 驗證碼至手機/信箱
   * @param channel 發送管道（cell／email）
   * @param contact 連絡方式：如果發送管道為手機，則填入手機號碼 如果發送管道為信箱，則填入信箱號碼
   */
  registerSendOtp(
    idNumber: string,
    channel: string,
    contact: string
  ): Observable<ApiResponse<null>> {
    const payload: RegisterSendOtpRequest = {
      idNo: idNumber,
      channel: channel,
      contact: contact,
    };

    return this.http.post<ApiResponse<null>>(
      API_ENDPOINTS.OTP_SESSION_REGISTERS,
      payload
    );
  }

  /**
   * 驗證 OTP 驗證碼
   * @param idNumber 身分證字號
   * @param otp OTP 驗證碼
   */
  registerValidateOtp(
    idNumber: string,
    otp: string
  ): Observable<ApiResponse<null>> {
    const payload: RegisterVerifyOtpRequest = {
      idNo: idNumber,
      otp: otp,
    };

    return this.http.post<ApiResponse<null>>(
      API_ENDPOINTS.OTP_VERIFY_REGISTERS,
      payload
    );
  }

  /**
   * 查詢是否為已存在信箱
   * @param email 信箱
   * @param idNo 身分證字號
   */
  registerVerifyEmailRegistered(idNo: string, email: string): Observable<ApiResponse<RegisterVerifyEmailRegisteredResponse>> {
    const payload: RegisterVerifyEmailRegisteredRequest = {
      idNo: idNo,
      email: email,
    };

    return this.http.post<ApiResponse<RegisterVerifyEmailRegisteredResponse>>(
      API_ENDPOINTS.VERIFY_EMAIL_REGISTERED,
      payload
    );
  }
}
